import React, { useMemo } from "react";
// import {Link} from "react-router-dom";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import SainoLogo from "../../../../images/logo/sales-simplify-logo.svg";
import { useHistory } from "react-router-dom";
// import SainoLogo1 from '../../../../images/sales_s_icon_300.png';

export function Brand() {
  const uiService = useHtmlClassService();

  const history = useHistory();

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(uiService.config, "aside.self.minimize.toggle"),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo(),
    };
  }, [uiService]);

  const handleBrandClick = () => {
    history.push("/activity/activity-list");
  };

  return (
    <>
      {/* begin::Brand */}
      <div className={`brand flex-column-auto aside-newtheme p-0 ${layoutProps.brandClasses}`} id="kt_brand">
        {/* begin::Logo */}
        {/* <Link to="" className="brand-logo">
          <img alt="saino" src={SainoLogo} style={{width: '50px', marginLeft: '50px'}}/> */}
        {/* <img alt="logo" src={layoutProps.headerLogo1}/> */}
        {/* </Link> */}
        {/* end::Logo */}
        <div onClick={handleBrandClick} className="d-flex justify-content-center align-items-center cursor-pointer" style={{ width: "50px", height: "50px", borderRadius: "50%", padding: "4px" }}>
          <img alt="saino" src={SainoLogo} style={{ height: "45px", marginTop: "15px" }} />
        </div>
        {layoutProps.asideSelfMinimizeToggle && (
          <>
            {/* begin::Toggle */}
            <button className="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
              <span className="svg-icon svg-icon-xl">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-double-left.svg")} />
              </span>
            </button>
            {/* end::Toolbar */}
          </>
        )}
      </div>
      {/* end::Brand */}
    </>
  );
}
